import { render } from "./TheHomepage.vue?vue&type=template&id=48151b54&scoped=true"
import script from "./TheHomepage.vue?vue&type=script&lang=js"
export * from "./TheHomepage.vue?vue&type=script&lang=js"

import "./TheHomepage.vue?vue&type=style&index=0&id=48151b54&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48151b54"]])

export default __exports__